
<template>

    <router-view/>
 
  

</template>

<script>
export default { 
  name: 'App'
}
</script>

<style lang="scss">
  @import './style/common';
  @import './style/commonwai';
  @import './style/animate.min';
  @import './style/commoncssanim';
  
</style>




// WEBPACK FOOTER //
// src/App.vue